import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import routes from '~routes';
import { Button, HStack, useToken } from '@chakra-ui/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var routeArray = Object.entries(routes);
var Navbar = function() {
    var router = useRouter();
    var isRoute = React.useCallback(function(route) {
        return router.route == route;
    }, [
        router.route
    ]);
    var ref = _slicedToArray(useToken('colors', [
        'blackAlpha.900'
    ]), 1), blackAlpha900 = ref[0];
    var bgColor = "".concat(blackAlpha900, "E6");
    var lighterBgColor = "".concat(blackAlpha900, "99");
    return(/*#__PURE__*/ _jsx(HStack, {
        bgColor: bgColor,
        borderBottomColor: "whiteAlpha.50",
        borderBottomWidth: "2px",
        d: [
            'none',
            'flex'
        ],
        insetX: 0,
        justify: "center",
        p: [
            2,
            4
        ],
        pos: "sticky",
        sx: {
            '@supports (backdrop-filter: blur(12px))': {
                backdropFilter: 'blur(12px)',
                bgColor: lighterBgColor
            },
            '@supports (-webkit-backdrop-filter: blur(12px))': {
                WebkitBackdropFilter: 'blur(12px)',
                bgColor: lighterBgColor
            }
        },
        top: 0,
        zIndex: "modal",
        children: routeArray.map(function(param) {
            var _param = _slicedToArray(param, 2), route = _param[0], name = _param[1];
            /*#__PURE__*/ return _jsx(Link, {
                href: route,
                passHref: true,
                children: /*#__PURE__*/ _jsx(Button, {
                    as: "a",
                    colorScheme: isRoute(route) ? 'yellow' : undefined,
                    fontWeight: isRoute(route) ? 'bold' : 'normal',
                    variant: "ghost",
                    children: name
                })
            }, name);
        })
    }));
};
export default Navbar;
